import { hashKey, useQuery } from '@tanstack/react-query';

import { observableToPromise } from '../shared/observableToPromise';

import { getSettingsPrivate } from './api';
import type { Settings } from './model';

export function useRelatedIdAccountSearchEnabled(settings?: Settings): boolean {
  const enabled = settings?.enableRelatedIdAccountSearch === true;
  const capability = useQuery({
    queryKey: ['vital', 'settings', 'related-id-account-search'],
    queryKeyHashFn: hashKey,
    queryFn: async ({ signal }) => {
      const response = await observableToPromise(getSettingsPrivate(), signal);
      return response.relatedIdAccountSearchEnabled === true;
    },
    enabled,
    staleTime: 0,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
  const bootstrapCapability =
    !settings?.error && !settings?.isFetching && settings?.relatedIdAccountSearchEnabled === true;
  return enabled && !capability.isError && (capability.data ?? bootstrapCapability);
}
